import * as React from "react";
import VimeoPlayer from "@vimeo/player";

export default class VideoPlayer extends React.Component {
  videoNode;
  player;

  componentDidMount() {
    this.player = new VimeoPlayer(this.videoNode, this.props);
    this.player.on("ended", this.openForm);
  }

  openForm() {
    const form = document.getElementById("claims-form");
    if (form) {
      form.classList.remove("invisible");
    }
  }

  render() {
    return <div ref={v => (this.videoNode = v)} className="embed-video" />;
  }
}
